import { useQuery } from "@apollo/client/react";
import { GET_ALL_ROLES } from "@/hooks";
import { enqueueSnackbar } from "notistack";
import { useEffect, useMemo } from "react";

interface Role {
  id: string;
  role: string;
  key: string;
  modules: any[];
  createdAt: string;
  updatedAt: string;
  value: string;
  label: string;
}

interface UseRolesListReturn {
  rolesList: Role[];
  loading: boolean;
}

interface GetAllRolesResponse {
  roles?: Role[];
  comRoles?: Role[];
}

/**
 * Custom hook to fetch the list of roles.
 * @param {object} props - The properties to be passed to the query.
 */
export function useRolesList(props?: Record<string, any>): UseRolesListReturn {
  const propsDefault = {};
  const variables = {
    ...propsDefault,
    ...(props || {}),
  };

  const { data, loading, error } = useQuery<GetAllRolesResponse>(
    GET_ALL_ROLES,
    {
      variables,
      errorPolicy: "all",
    },
  );

  useEffect(() => {
    if (error) {
      enqueueSnackbar(error.message, { variant: "error" });
    }
  }, [error]);

  const rolesList = useMemo(() => {
    return data?.roles || data?.comRoles || [];
  }, [data?.roles, data?.comRoles]);

  return {
    rolesList,
    loading,
  };
}
